/**
 * Alive Water — Lottie in benefit cards (same JSON URLs as product.delivery custom-blurb-slider).
 */
(function () {
  'use strict';

  var lottiePromise = null;

  function loadLottieLib(cb) {
    if (window.lottie) {
      cb();
      return;
    }
    if (lottiePromise) {
      lottiePromise.then(cb);
      return;
    }
    lottiePromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
      s.async = true;
      s.onload = function () {
        resolve();
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    lottiePromise.then(cb);
  }

  function destroyInside(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll('[data-alive-benefit-lottie][data-lottie-inited]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n._aliveBenefitLottie) {
        try {
          n._aliveBenefitLottie.destroy();
        } catch (e) {}
        n._aliveBenefitLottie = null;
      }
      n.removeAttribute('data-lottie-inited');
      while (n.firstChild) {
        n.removeChild(n.firstChild);
      }
    }
  }

  function initHost(host) {
    if (!host || host.getAttribute('data-lottie-inited') === '1') return;
    var src = host.getAttribute('data-lottie-src');
    if (!src) return;

    loadLottieLib(function () {
      if (!window.lottie || !host.isConnected) return;
      if (host.getAttribute('data-lottie-inited') === '1') return;

      var anim = window.lottie.loadAnimation({
        container: host,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: src,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid meet',
          progressiveLoad: true
        }
      });
      host._aliveBenefitLottie = anim;
      host.setAttribute('data-lottie-inited', '1');
    });
  }

  function scan(root) {
    var scope = root || document;
    var hosts = scope.querySelectorAll('[data-alive-benefit-lottie]:not([data-lottie-inited])');
    for (var i = 0; i < hosts.length; i++) {
      initHost(hosts[i]);
    }
  }

  function onReady() {
    loadLottieLib(function () {
      scan(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (!t || !t.querySelector) return;
    var sec = t.matches('[data-alive-benefits]') ? t : t.querySelector('[data-alive-benefits]');
    if (!sec) return;
    destroyInside(sec);
    loadLottieLib(function () {
      scan(sec);
    });
  });
})();
